import { render } from "./navigation.vue?vue&type=template&id=1af2c4be&scoped=true&ts=true"
import script from "./navigation.vue?vue&type=script&lang=ts"
export * from "./navigation.vue?vue&type=script&lang=ts"

import "./navigation.vue?vue&type=style&index=0&id=1af2c4be&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af2c4be"]])

export default __exports__